import React from "react";
import style from "../styles.module.scss";
import { useSelector, useDispatch } from "react-redux";


function ProcessTable() {
    const mTable = useSelector((store) => store.masterTable);
    const dispatch = useDispatch();

    return (
        <div className={`${style.mainTopLeft}`}>
            <table>
                <thead>
                    <tr>
                        <th>Process</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className={`${mTable.proc === "USP" && style.active}`} onClick={() => dispatch({type: "setMaster", proc: "USP", uo: null, step: null})}>
                            USP
                        </td>
                    </tr>
                    <tr>
                        <td className={`${mTable.proc === "DSP" && style.active}`} onClick={() => dispatch({type: "setMaster", proc: "DSP", uo: null, step: null})}>
                            DSP
                        </td>
                    </tr>
                </tbody>
            </table>
            <table>
                <tbody>
                <tr>
                    <td className={`${mTable.proc === "UNIT" && style.active}`}
                        onClick={() => dispatch({type: "setMaster", proc: "UNIT", uo: null, step: null})}>
                        Unit
                    </td>
                </tr>
                <tr>
                    <td className={`${mTable.proc === "CRI" && style.active}`}
                        onClick={() => dispatch({type: "setMaster", proc: "CRI", uo: null, step: null})}>
                        Criticality
                    </td>
                </tr>
                </tbody>
            </table>

            <table>
                <tbody>
                <tr>
                    <td className={`${mTable.proc === "PLANT" && style.active}`}
                        onClick={() => dispatch({type: "setMaster", proc: "PLANT", uo: null, step: null})}>
                    Plant
                    </td>
                </tr>
                <tr>
                    <td className={`${mTable.proc === "PROJECT" && style.active}`}
                        onClick={() => dispatch({type: "setMaster", proc: "PROJECT", uo: null, step: null})}>
                        Project
                    </td>
                </tr>
                <tr>
                    <td className={`${mTable.proc === "MBRNO" && style.active}`}
                        onClick={() => dispatch({type: "setMaster", proc: "MBRNO", uo: null, step: null})}>
                        MBR No.
                    </td>
                </tr>
                {/* <tr>
                        <td className={`${mTable.proc === "STAGE" && style.active}`} onClick={() => dispatch({type: "setMaster", proc: "STAGE", uo: null, step: null})}>
                        Stage
                        </td>
                    </tr> */}
                </tbody>
            </table>
        </div>
    );
}

export default ProcessTable;
